const moduleRoutes = import.meta.glob('./module/*/routes.js', { eager: true });
const App = () => import('./App.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    component: App,
    meta: {
      requiresAuth: true,
      breadcrum: 'Home',
      icon: 'home',
    },
    children: [
      ...Object.values(moduleRoutes).flatMap((module) => module.default),
    ],
  },
];

export default routes;
